import type { IDynamicInfoProps, IImageTransform, ILayerProps, StretchOptionType } from '@/version-types';

export enum HistoryType {
    /** 转换为背景 */
    CONVERT_BACKGROUND_TO_IMAGE = 'convertBackgroundToImage',
    /** 批量更新背景 */
    BATCH_UPDATE_BACKGROUND = 'batchUpdateBackground',
}

export interface IConvertBackgroundToImageData {
    backgroundLayer: ILayerProps;
    imageLayer: ILayerProps;
    bgOptions: {
        url: string;
        backgroundColor: string;
    };
}

export interface IBatchUpdateBackgroundData {
    newLayers: ILayerProps[];
    oldLayers: ILayerProps[];
    stageSelection: number[];
}

export interface IBackgroundLayerCreateProps {
    backgroundColor: string;
    width: number;
    height: number;
}

export interface IBackgroundLayerUpdateProps {
    url: string;
    backgroundColor: string;
    backgroundGradient?: {
        colors: { color: string; value: number }[];
        angle: number;
    };
    id?: number;
    stretchOption?: StretchOptionType;
    imageTransform?: IImageTransform;
    opacity?: number;
    naturalHeight?: number;
    naturalWidth?: number;
    isAILayer?: boolean;
    dynamicInfo?: IDynamicInfoProps;
}
